
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { formatDistanceToNow } from "date-fns"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();

  // If it's more than 7 days ago, show the date
  if (now.getTime() - date.getTime() > 7 * 24 * 60 * 60 * 1000) {
    return date.toLocaleDateString();
  }

  // Otherwise show relative time
  return formatDistanceToNow(date, { addSuffix: true });
}

export function truncateToWords(text: string, wordCount: number): string {
  const words = text.split(' ');
  if (words.length <= wordCount) {
    return text;
  }
  return words.slice(0, wordCount).join(' ') + '...';
}
